import * as React from 'react';

function SvgTabFilter(props) {
  return (
    <svg width={10} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.184 10c-.305 0-.613-.232-.613-.751V4.813L.239 1.129A.957.957 0 01.034.796.583.583 0 01.047.368.582.582 0 01.355.072.954.954 0 01.739 0H9.26c.147 0 .276.024.384.072.143.063.25.165.308.296a.583.583 0 01.013.428.957.957 0 01-.205.333L6.43 4.813v2.669c0 .504-.293 1.126-.682 1.447l-1.04.857c-.172.142-.348.214-.523.214z"
        fill="#BFBFBF"
      />
    </svg>
  );
}

export default SvgTabFilter;
